export const config = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  apiBase: import.meta.env.VITE_API_BASE_URL ?? '',
  /** แสดงบัญชี demo prefilled + hint บนหน้า login — เปิดเฉพาะ dev/demo (ปิดโดย default = ปลอดภัยกับ production) */
  demoHints: import.meta.env.VITE_DEMO_HINTS === '1',
};

/** ต่อ API จริงได้ไหม (มี env ครบ) — ไม่ครบ = โหมด demo */
export const isConfigured = Boolean(config.supabaseUrl && config.anonKey && config.apiBase);
